export default "__VITE_ASSET__BRLxUj$m__"